import { createStore, applyMiddleware, compose, combineReducers } from "redux";
import thunkMiddleware from "redux-thunk";
import persistState from "redux-localstorage";



import user from './reducers/user';
import counter from "./reducers/counterSample";
import userProfile from "./reducers/userProfile";
import course from "./reducers/course";
import orders from "./reducers/order";

// Reducer import go here.

const appReducer = combineReducers({
    user: user,
    counter: counter,
    course: course,
    orders: orders,
    profile: userProfile
    // Reducer list goes here.
});

const rootReducer = (state, action) => {
  if (action.type === 'USER_LOGGED_OUT') {
    state = undefined;
  }

  return appReducer(state, action);
};

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  rootReducer,
  composeEnhancers(
    applyMiddleware(thunkMiddleware),
    persistState(/*paths, config*/)
  )
);

export default store;
